import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}
export const CATEGORIEVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(false, [Validators.required, Validators.maxLength(15)])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
      ['idSsFamille', new FormInfo(false, [])],
      ['seuil', new FormInfo(false, [Validators.min(0), Validators.max(25)])],
      ['codeTva', new FormInfo(false, [])],
      ['creaEnveloppe', new FormInfo(false, [])]

    ]),
    EDIT: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(true, [Validators.required, Validators.maxLength(15)])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
      ['idSsFamille', new FormInfo(false, [])],
      ['seuil', new FormInfo(false, [Validators.min(0), Validators.max(25)])],
      ['codeTva', new FormInfo(false, [])],
      ['creaEnveloppe', new FormInfo(false, [])]
    ]),
    VISUALIZE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(true, [Validators.required, Validators.maxLength(15)])],
      ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
      ['idSsFamille', new FormInfo(true, [])],
      ['seuil', new FormInfo(true, [Validators.min(0), Validators.max(25)])],
      ['codeTva', new FormInfo(true, [])],
      ['creaEnveloppe', new FormInfo(true, [])]
    ])
  };
